import { HttpApi } from "@effect/platform";
import { AiAgentGroup } from "./ai-agent";
import { AttachmentGroup } from "./attachment";
import { AutomationExecutionGroup } from "./automation-execution";
import { ChatWidgetGroup } from "./chat-widget";
import { DefaultRuleGroup } from "./default-rule";
import { HealthGroup } from "./health";
import { IntegrationGroup } from "./integration";
import { MacroGroup } from "./macro";
import { MeGroup } from "./me";
import { StreamGroup } from "./stream";
import { SupportTicketGroup } from "./support-ticket-comment";
import { SupportTicketCountsGroup } from "./support-ticket-counts";
import { TagGroup } from "./tag";
import { TeamNotificationGroup } from "./team-notification";
import { UserGroupGroup } from "./user-group";
import { ViewFolderGroup } from "./view-folder";
import { VoiceGroup } from "./voice";
import { WebhookGroup } from "./webhook";

export class Api extends HttpApi.make("effect-api")
  .add(HealthGroup)
  .add(MeGroup)
  .add(SupportTicketGroup)
  .add(SupportTicketCountsGroup)
  .add(IntegrationGroup)
  .add(WebhookGroup)
  .add(AttachmentGroup)
  .add(TeamNotificationGroup)
  .add(StreamGroup)
  .add(AiAgentGroup)
  .add(MacroGroup)
  .add(TagGroup)
  .add(UserGroupGroup)
  .add(ViewFolderGroup)
  .add(ChatWidgetGroup)
  .add(AutomationExecutionGroup)
  .add(VoiceGroup)
  .add(DefaultRuleGroup) {}
